import accounting from 'accounting';

export function formatCurrency(amount: number, currency: string = 'vnđ') {
  return accounting.formatMoney(amount, currency, 0, ',', '.', '%v %s');
}

export function formatNumber(amount: number, decimalPlaces: number = 0) {
  return accounting.formatMoney(amount, '', decimalPlaces, ',', '.', '%v');
}

export function toNumber(amount: string | number) {
  if (!amount) return 0;
  if (typeof amount === 'number') {
    return amount;
  }
  return parseFloat(amount.replace(/,/g, ''));
}
